import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CSSProperties } from '../../../models';
import { LabelRoleSize } from '../../../types/common.types';

@Component({
  selector: 'idp-label-with-link',
  templateUrl: './label-with-link.component.html',
  styleUrls: ['./label-with-link.component.scss']
})
export class LabelWithLinkComponent {
  @Input() linkLabel = '';
  @Input() description = '';
  @Input() labelSize: LabelRoleSize = 'extra-large';
  @Input() styles: CSSProperties = {} as CSSProperties;
  @Output() clicked: EventEmitter<boolean> = new EventEmitter();

  notify(event: boolean): void {
    this.clicked.emit(event);
  }
}
